import { render, staticRenderFns } from "./TaxonomiesView.vue?vue&type=template&id=c39477f4&scoped=true"
import script from "./TaxonomiesView.vue?vue&type=script&lang=js"
export * from "./TaxonomiesView.vue?vue&type=script&lang=js"
import style0 from "./TaxonomiesView.vue?vue&type=style&index=0&id=c39477f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39477f4",
  null
  
)

export default component.exports